import type { ChatMessage, File } from '@ztechapps/common.contract'

// The thread's one attachment source: every message already renders its own files inline, so any
// consolidated list (the side-panel section, the legacy under-composer row) flattens the same
// messages rather than re-querying.
export const collectChatAttachments = (messages?: ChatMessage[]): File[] => {
  const attachments: File[] = []
  for (const message of messages ?? []) {
    for (const attachment of message.attachments ?? []) {
      attachments.push(attachment)
    }
  }
  return attachments
}
